import { Auth } from 'connex-cds';
import React from 'react';
import { useParams } from 'react-router-dom';
import { getFeatureFlaggedMenuConfig } from './menu-config';
import { useFeatureFlags } from '../../../providers/feature-flags-provider';

export const IFrameAuthenticated = ({ children }) => {
  const { entityRef } = useParams();
  const { getFlagValue } = useFeatureFlags() ?? {};
  const featureFlaggedMenuConfig = React.useMemo(() => getFeatureFlaggedMenuConfig(getFlagValue), [getFlagValue]);

  return <Auth.IFrameAuthenticated entityRef={entityRef} menuConfig={featureFlaggedMenuConfig} />;
};
